export const GROUP_TYPES = {
  csvtreenodebindings: {
    id: 'csvtreenodebindings',
    name: ['first', 'last'],
    count: 'direct_reports',
    genericLabel: 'label.CUSTOM_DIRECTORY_GROUP'
  },
  googlegroupbindings: {
    id: 'googlegroupbindings',
    name: 'name',
    count: 'directMembersCount',
    genericLabel: 'label.GOOGLE_GROUP'
  },
  googleorgbindings: {
    id: 'googleorgbindings',
    name: 'name',
    count: 'directMembersCount',
    genericLabel: 'label.GOOGLE_ORG'
  },
  o365groupbindings: {
    id: 'o365groupbindings',
    name: 'displayName',
    count: 'directMembersCount',
    genericLabel: 'label.MICROSOFT_GROUP'
  },
  oktagroupbindings: {
    id: 'oktagroupbindings',
    name: 'name',
    count: 'directMembersCount',
    genericLabel: 'label.OKTA_GROUP'
  }
};
